import React from 'react';
import MUIDataTable from "mui-datatables";
import withWidth from '@material-ui/core/withWidth';

class MuiThemeDataTable extends React.PureComponent {

            options = {
            expandableRows: this.props.expandableRows,
            renderExpandableRow: (rowData, rowMeta) => this.props.renderExpandableRow(rowData, rowMeta),
            filterType: 'checkbox',
            selectableRows: false,
            download: this.props.hideDownloadIcon,
            search: this.props.hideSearchIcon,
            filter: this.props.hideFilterIcon,
            elevation: 0,
            viewColumns: this.props.viewColumnsIcon,
            rowHover: false,
            pagination:this.props.pagination!==false?true:false,
            rowsPerPageOptions: [10, 25, 50],
            responsive: "scroll",
            print: false,
            customSort : this.props.customSort,
            textLabels: {
                body: {
                    noMatch: "No Data",
                    toolTip:"Sort"
                },
                pagination: {
                    rowsPerPage:"Rows per page",
                    displayRows: "of"
                 },
                toolbar: {
                    search: "Search",
                    downloadCsv: "Download",
                    viewColumns: "View Columns",
                    filterTable:"FilterTable"
                  },
                filter: {
                    title: "Filters",
                    reset: "Reset",
                  },
                  viewColumns: {
                    title:"Show coloumns"
                  }
            }
            };
        render() {
            let columns = [];
            // if((this.props.width === "sm" || this.props.width === "xs") && this.props.tableContent === "patientList" ){
            //     columns.push(this.props.columns[1]);
            //     columns.push(this.props.columns[0]);
            //     this.options.onRowClick = (rowData, rowMeta) => {
            //         this.props.rowDetailsRedirectFunction(rowData, rowMeta);
            //     };
            // } else if(this.props.width === "sm" || this.props.width === "xs"){
            //     this.props.smallScreenTableColumnDisplayIndex.forEach(element => {
            //         columns.push(this.props.columns[element]);
            //     });
            // } else {
                this.options.expandableRows = false;
                columns = this.props.columns;
            // }
        return (
            <MUIDataTable
            key={columns.length}
            title={this.props.title}
            data={this.props.rows}
            columns={columns}
            options= {this.options}
            className="printStyle"
        />);
    }
}
export default withWidth()((MuiThemeDataTable));